import React from 'react'

interface BrowserContextProps {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  windowWidth: number
  windowHeight: number
  scrollPosition: number
}

export const BrowserContext = React.createContext({} as BrowserContextProps)
